import axiosRequest from "@/utils/axios-utils"

export const storeLocator = async (prodId, token) => {
  const config = {
    method: 'get',
    url: `/mstore/store-locator/${prodId}`,
    headers: {
      Authorization: `Bearer ${token}`,
      admin: "Bearer " + process.env.MW_ADMIN_TOKEN,
    }
  }
  try {
    const req = await axiosRequest(config)
    console.log('storeLocator', req)
    return req
  } catch (error) {
    console.log('storeLocator error', error)
    return error
  }
}

export const productRatings = async (token,sku) => {
  const config = {
    method: 'get',
    url: `/productReviews/${sku}`,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }
  try {
    const req = await axiosRequest(config)
    return req
  } catch (error) {
    return error
  }
}